var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.047.6c2.64 0 5.016.624 7.128 1.872 2.112 1.2 3.744 2.904 4.896 5.112 1.2 2.16 1.8 4.608 1.8 7.344 0 2.736-.6 5.232-1.8 7.488-1.152 2.256-2.784 4.032-4.896 5.328-2.112 1.296-4.488 1.944-7.128 1.944H5.143V48.84c0 .624-.216 1.152-.648 1.584-.384.384-.888.576-1.512.576s-1.152-.192-1.584-.576c-.384-.432-.576-.96-.576-1.584V2.76c0-.624.192-1.128.576-1.512C1.83.816 2.359.6 2.983.6h17.064zm0 24.912c2.784 0 5.04-1.008 6.768-3.024 1.728-2.016 2.592-4.536 2.592-7.56 0-2.976-.864-5.4-2.592-7.272-1.728-1.872-3.984-2.808-6.768-2.808H5.143v20.664h14.904z",
    fill: "currentColor"
  })));
}
export default SvgP;